<template>
  <b-modal id="modal-add-smd-user" size="md" no-close-on-backdrop>
    <template #modal-title>
      <div class="d-flex align-items-center">
        <feather-icon size="20" icon="UserPlusIcon" class="mr-05" />
        <span class="fs-18">Tambah User Sosmed</span>
      </div>
    </template>
    <loader-component v-if="is_loading" />
    <b-card no-body class="mb-0">
      <b-card-body>
        <validation-observer ref="formRules">
          <b-form>
            <!-- Platform -->
            <b-form-group>
              <validation-provider #default="{ errors }" name="Platform" rules="required">
                <label for="platform">Platform <span class="text-danger">*</span></label>
                <select v-model="user_data.platform" id="platform" class="form-control">
                  <option value="" disabled selected>Pilih Platform</option>
                  <option value="facebook">Facebook</option>
                  <option value="instagram">Instagram</option>
                </select>
                <small class="text-danger" style="font-size:10px">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <!-- Username -->
            <b-form-group>
              <validation-provider #default="{ errors }" name="Username" rules="required">
                <label for="smd-username">Username <span class="text-danger">*</span></label>
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="UserIcon" />
                  </b-input-group-prepend>
                  <b-form-input v-model="user_data.username" id="smd-username" placeholder="Masukkan Username" />
                </b-input-group>
                <small class="text-danger" style="font-size:10px">{{ errors[0] }}</small>
                <small v-if="username_taken" class="text-danger" style="font-size:10px">
                  Username sudah digunakan di platform ini!
                </small>
              </validation-provider>
            </b-form-group>
            <!-- Password -->
            <b-form-group>
              <validation-provider #default="{ errors }" name="Password" rules="required">
                <label for="smd-password">Password <span class="text-danger">*</span></label>
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="KeyIcon" />
                  </b-input-group-prepend>
                  <b-form-input v-model="user_data.password" id="smd-password" placeholder="Masukkan Password" type="password" />
                </b-input-group>
                <small class="text-danger" style="font-size:10px">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <!-- Role -->
            <b-form-group>
              <validation-provider #default="{ errors }" name="Role" rules="required">
                <label for="smd-role">Role <span class="text-danger">*</span></label>
                <select v-model="user_data.role" id="smd-role" class="form-control">
                  <option value="" disabled selected>Pilih Role</option>
                  <option value="admin">Admin</option>
                  <option value="user">User</option>
                </select>
                <small class="text-danger" style="font-size:10px">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
    <template #modal-footer>
      <b-button variant="outline-danger" size="sm" class="float-right mr-05" @click="cancel">Batal</b-button>
      <b-button variant="outline-info" size="sm" class="float-right" @click.prevent="submit">Simpan</b-button>
    </template>
  </b-modal>
</template>

<script>
import { BModal, VBModal, BCard, BCardBody, BForm, BFormGroup, BInputGroup, BInputGroupPrepend, BFormInput, BButton } from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import useJwt from "@/auth/jwt/useJwt";
import floating_loader from "@/views/components/floatingLoader.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  name: "addSmdUser",
  components: {
    ValidationProvider, ValidationObserver,
    BModal, BCard, BCardBody, BForm, BFormGroup,
    BInputGroup, BInputGroupPrepend, BFormInput, BButton,
    "loader-component": floating_loader,
  },
  data() {
    return {
      is_loading: false,
      username_taken: false,
      user_data: { platform: "", username: "", password: "", role: "" },
      required,
    };
  },
  methods: {
    submit() {
      this.$refs.formRules.validate().then((success) => {
        if (success) {
          this.is_loading = true;
          this.username_taken = false;
          const api = process.env.VUE_APP_API_URL + "smd-users/save";
          useJwt.axiosIns
            .post(api, { data: { ...this.user_data } })
            .then(() => {
              this.resetForm();
              this.$bvModal.hide("modal-add-smd-user");
              this.$parent.getData();
              this.$toast({ component: ToastificationContent, position: "top-right",
                props: { title: "Berhasil", icon: "CheckCircleIcon", variant: "success", text: "User sosmed berhasil ditambahkan" },
              });
            })
            .catch((err) => {
              if (err.response && err.response.status === 400) this.username_taken = true;
            })
            .finally(() => { this.is_loading = false; });
        }
      });
    },
    cancel() {
      this.resetForm();
      this.$bvModal.hide("modal-add-smd-user");
    },
    resetForm() {
      this.user_data = { platform: "", username: "", password: "", role: "" };
      this.username_taken = false;
    },
  },
  directives: { "b-modal": VBModal },
};
</script>

<style scoped>
.modal-title { padding-top: 1rem; padding-bottom: 1rem; font-size: 20px !important; font-weight: bold; }
</style>
